import repository from "../Repository";

export default {
  // 要配慮者情報の一覧を取得する
  async getConsiderationPersons(manageGrpId, screenId) {
    return await repository.post(
      `consideration_person_info`,
      {
        manage_grp_id: manageGrpId
      },
      {
        headers: { s: screenId }
      }
    );
  },

  // 要配慮者情報を登録する
  async registerConsiderationPerson(personInfo, screenId) {
    const res = await repository.post(`consideration_person_ope`, personInfo, {
      headers: { s: screenId }
    });
    return res;
  },

  // 要配慮者情報の一覧を編集する
  async updateConsiderationPerson(personInfo, screenId) {
    const res = await repository.patch(`consideration_person_ope`, personInfo, {
      headers: { s: screenId }
    });
    return res;
  }
};
